import FileViewer from "components/Launchables/Deploy/shared/FileViewer";
import { Environment } from "components/Environment/utils/types";
import React from "react";
interface NotebookSettingsProps {
  environment: Environment;
  notebookList: any[];
}
const NotebookSettings: React.FC<NotebookSettingsProps> = (props) => {
  return (
    <>
      <div className="flex flex-row items-end ">
        <div className="mr-3"></div>
      </div>
      <hr className="w-[100%] my-3 dark:border dark:border-zinc-800" />
      <div>
        {props.environment?.build?.files &&
          props.environment?.build?.files?.length > 0 &&
          props.environment?.build?.files?.[0]?.file_url && (
            <FileViewer
              file={props.environment?.build?.files?.[0]?.file_url || ""}
            />
          )}
      </div>
    </>
  );
};

export default NotebookSettings;
